<template>
    <el-row class="searchDetail">
        <el-page-header @back="goBack" content="问题详情"></el-page-header>
        <el-divider></el-divider>
        <el-row class="mains">
            <el-row class="content">
                <el-col :span="24"><div class="title">C01-01R客户绑定遥控开关的主账号及密码遗失无法找回</div></el-col>
                <el-col :span="24"><div class="reTitle">客户绑定遥控开关的主账号及密码遗失无法找回，麻烦帮忙解绑一下账号，二维码及卡号见附件</div></el-col>
                <el-col :span="24">
                    <div class="downld">文件下载:</div>
                    <div class="docmt">
                        <el-col :span="4">1</el-col>
                        <el-col :span="4">2</el-col>
                        <el-col :span="4">3</el-col>
                        <el-col :span="4">4</el-col>
                        <el-col :span="4">4</el-col>
                        <el-col :span="4">4</el-col>
                    </div>
                </el-col>
            </el-row>
        </el-row>

        <el-divider></el-divider>

        <el-row class="eva">
            <el-col :span="24">该问题是否对您有帮助？</el-col>
            <el-col :span="24">
                <el-button type="text">是的</el-button>
                <el-button type="text">没有</el-button>
            </el-col>
        </el-row>
    
    
    </el-row>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {
    goBack(){
        this.$router.go(-1)
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
h5{
    color: #666666;
}
.searchDetail{
    padding: 20px;
    background: #fff;
    .mains{
        .el-col{
            margin-top: 20px;
        }
        .title{
            color: #333;
            font-weight: 600;
            font-size: 20px;
        }
        .reTitle{
            font-size: 16px;
            color: #666666;
        }
        .docmt{
            margin-bottom: 50px;
        }
    }

    .eva{
        .el-col:nth-child(1){
            font-size: 16px;
            color: #666666;
        }
        .el-col:nth-child(2){
            margin-top: 10px;
        }
    }
}
</style>